import { render } from "./PartnerLogos.vue?vue&type=template&id=1b970690&scoped=true"
import script from "./PartnerLogos.vue?vue&type=script&lang=js"
export * from "./PartnerLogos.vue?vue&type=script&lang=js"

import "./PartnerLogos.vue?vue&type=style&index=0&id=1b970690&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b970690"]])

export default __exports__